// src/layouts/RootLayout.jsx

import { Outlet } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

import PullToRefresh from 'react-simple-pull-to-refresh';
import { ArrowDown, LoaderCircle } from 'lucide-react';


export function RootLayout() {
  const handleRefresh = () => {
    window.location.reload();
  };
  
  const PullingIndicator = (
    <div className="flex items-center justify-center gap-2 p-4 text-gray-500">
      <ArrowDown className="h-5 w-5" />
      <span className="text-sm">Puxe para atualizar</span>
    </div>
  );

  return (
    <div className="flex min-h-screen flex-col bg-gray-50 dark:bg-gray-950">
      <Header />
      <main className="flex-grow p-4">
      <PullToRefresh onRefresh={handleRefresh} 
        pullingContent={PullingIndicator}
        resistance={5}
      >
        <div className="mx-auto w-full max-w-7xl p-4 sm:p-6 lg:p-8">
          <Outlet />
        </div>
          

      </PullToRefresh>
      </main>
      <Footer />
    </div>
  );
}
